<template>
    <div class="cookie-consent-overlay ">
        <div class="card bg-transparent border-0">
            <div class="card-body text-start bg-transparent text-light">
                <div class="f-help">
                    {{ $t("cookie_consent.message") }}
                </div>
                <div class="f-help"
                     v-html="$t('cookie_consent.cta_to_modal')"></div>
                <div>
                    <div class="d-flex justify-content-end ">
                        <button class="btn btn-light me-2"
                                :class="{ 'disabled': loading }"
                                :disabled="loading"
                                type="button"
                                @click.prevent="storeCookieValue()">
                            {{ $t("cookie_consent.accept") }}
                        </button>
                        <button class="btn btn-dark"
                                :class="{ 'disabled': loading }"
                                :disabled="loading"
                                type="button"
                                @click.prevent="storeCookieValue()">
                            {{ $t("cookie_consent.decline") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import TitleSection from "~concierge/components/TitleSection.vue";
import CustomCheckbox from "~concierge/components/CustomCheckbox.vue"
import AsyncImage from "~concierge/components/AsyncImage.vue"
import { defineComponent, ref } from 'vue';
import { usePrivacyPolicyModalStore } from '~concierge/store/privacyPolicyModalStore'
import axios, { AxiosError } from 'axios'


export default defineComponent({
    name: "ConsentQuestion",
    components: { CustomCheckbox, AsyncImage, TitleSection },
    setup() {
        const privacyPolicyModalStore = usePrivacyPolicyModalStore();

        return {
            privacyPolicyModalStore,
        }
    },
    emits: ['cookie-compliance'],
    data() {
        return {
            editingOther: false,
            hasImages: false,
            consent: ref(false),
            loading: ref(false),

        }
    },
    mounted() {
        this.setupEventListener();
    },
    methods: {
        async storeCookieValue(): Promise<void> {
            this.loading = true
            try {
                await axios.patch(route('conciergeForm.CookieConsent'), {
                    consentCookieCompliance: this.consent,
                })
                this.$emit('cookie-compliance', true)
                this.loading = false
            } catch (error: unknown | Error | AxiosError) {
                this.loading = false
                throw error
            }

        },
        setupEventListener() {
            const privacyPolicyElement = document.getElementById('privacyPolicy');
            if (privacyPolicyElement) {
                privacyPolicyElement.style.cursor = 'pointer';
                privacyPolicyElement.addEventListener('click', this.handlePrivacyPolicyClick);
            }
        },
        handlePrivacyPolicyClick(event: Event) {
            this.privacyPolicyModalStore.openModal()
        },
    },
});
</script>

<style lang="scss" scoped>
:deep(em#privacyPolicy) {
    text-decoration: underline;
    transition: all 0.3s ease-in-out;

    &:hover {
        text-decoration: none;
    }
}

.cookie-consent-overlay {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    padding: 1rem;
    z-index: 1000;

    .btn {
        font-size: var(--font-size-smaller);
    }
}
</style>
